export default function SetColorDialogHelpfulTips() {
  return (
    <>
      Helpful tips
      <ul>
        <li>You can select rows in the table with the checkboxes</li>
        <li>Multi-select is enabled with shift-click and control-click</li>
        <li>The "Move selected items up/down" can re-arrange subtracks</li>
        <li>Sorting the data grid itself can also re-arrange subtracks</li>
        <li>Changes are applied when you hit Submit</li>
        <li>You can click and drag the dialog box to move it on the screen</li>
        <li>
          Columns in the table can be hidden using a vertical '...' menu on the
          right side of each column
        </li>
      </ul>
    </>
  )
}
